import { Link } from "react-router-dom";

/** variant: primary | default | ghost | danger; size: md | sm; `to` renders a Link. */
export function HxButton({ variant = "default", size = "md", to, className = "", children, ...rest }) {
  const cls = [
    "hx-btn",
    variant !== "default" && `hx-btn--${variant}`,
    size === "sm" && "hx-btn--sm",
    className,
  ].filter(Boolean).join(" ");
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  return <button className={cls} {...rest}>{children}</button>;
}
